module.exports = __webpack_public_path__ + "static/media/logo-ai2-white-withText-micro.0d210bc8.svg";